module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ru-f760036294e1fff52a9a88663d0d7a46.svg";